exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required-feedback[data-v-19689a84]{width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545\n}", ""]);

// exports
